import React from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  SimpleGrid,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { FORME_CERCHIO } from '../../constants/formeCerchio';
import { FORME_CERCHIO_ICONS } from '../../assets/forme-cerchio/icons';

/**
 * @param {{ value: string, onChange: (next: string) => void, hideLabel?: boolean }} props
 */
function FormaCerchioPicker({ value, onChange, hideLabel = false }) {
  const cardBg = useColorModeValue('white', 'gray.800');
  const captionColor = useColorModeValue('gray.600', 'gray.400');

  const handleSelect = (formaValue) => {
    if (value === formaValue) {
      onChange('');
    } else {
      onChange(formaValue);
    }
  };

  return (
    <FormControl>
      {!hideLabel ? (
        <FormLabel fontSize="sm">Forma del cerchio</FormLabel>
      ) : null}
      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={3}>
        {FORME_CERCHIO.map((forma) => {
          const selected = value === forma.value;
          const Icon = FORME_CERCHIO_ICONS[forma.icon];

          return (
            <Box
              key={forma.value}
              as="button"
              type="button"
              role="button"
              aria-pressed={selected}
              onClick={() => handleSelect(forma.value)}
              cursor="pointer"
              textAlign="center"
              p={3}
              borderRadius="md"
              border={
                selected ? '2px solid #36a9e1' : '1px solid rgba(59,35,90,.15)'
              }
              bg={selected ? 'rgba(54,169,225,.08)' : cardBg}
              color="gray.700"
              _dark={{ color: 'gray.200' }}
              transition="border-color 0.15s, background 0.15s"
              _hover={{
                borderColor: selected ? '#36a9e1' : 'rgba(59,35,90,.3)',
              }}
            >
              {Icon ? (
                <Box
                  as={Icon}
                  boxSize="48px"
                  mx="auto"
                  mb={2}
                  display="block"
                  aria-hidden
                />
              ) : null}
              <Text fontWeight="medium" fontSize="sm">
                {forma.label}
              </Text>
              <Text
                fontSize="xs"
                color={captionColor}
                mt={1}
                lineHeight="short"
              >
                {forma.caption}
              </Text>
            </Box>
          );
        })}
      </SimpleGrid>
    </FormControl>
  );
}

export default FormaCerchioPicker;
